(function () {
  'use strict';

  var incompleteScheduleText = 'Pay remaining amount on';

  function normaliseText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function repairDeferredPurchaseConsent() {
    var consent = document.querySelector('#shopify-buyer-consent[data-consent-type="subscription"]');

    if (!consent || consent.getAttribute('data-lgm-deferred-consent') === 'true') {
      return;
    }

    var policyButton = consent.querySelector('#shopify-subscription-policy-button');

    consent.textContent = 'This cart includes a preorder. By continuing, I agree to the ';

    if (policyButton) {
      policyButton.textContent = 'cancellation policy';
      consent.appendChild(policyButton);
    } else {
      var policyText = document.createTextNode('cancellation policy');
      consent.appendChild(policyText);
    }

    consent.appendChild(document.createTextNode(' and, where a balance remains, authorize its collection under the payment schedule shown above.'));
    consent.setAttribute('data-lgm-deferred-consent', 'true');
  }

  function repairDibsScheduleText() {
    var descriptions = document.querySelectorAll('.lb-ordereasy-payment-option-description');

    descriptions.forEach(function (description) {
      if (normaliseText(description.textContent) !== incompleteScheduleText) {
        return;
      }

      var option = description.closest('.lb-ordereasy-payment-option-text-content');
      var title = option ? option.querySelector('.lb-ordereasy-payment-option-title') : null;
      var amountMatch = title ? normaliseText(title.textContent).match(/^Partial payment\s*-\s*(.+)$/i) : null;
      var depositText = amountMatch ? amountMatch[1] + ' deposit today.' : 'Deposit due today.';

      description.textContent = depositText + ' Remaining balance due when your order is ready for dispatch.';
      description.setAttribute('data-lgm-dibs-schedule-fallback', 'true');
    });
  }

  function repairDibsAvailableVariantButton() {
    var productJson = document.querySelector('[id^="ProductJson-"]');
    var variantSelect = document.querySelector('select[name="id"]');
    var buttonText = document.querySelector('[id^="AddToCartText-"]');

    if (!productJson || !variantSelect || !buttonText) {
      return;
    }

    var product;

    try {
      product = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    var selectedVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(variantSelect.value);
    });

    if (!selectedVariant) {
      return;
    }

    var sellingPlanAllocations = selectedVariant.selling_plan_allocations || [];
    var currentButtonText = normaliseText(buttonText.textContent).toLowerCase();
    var hasStalePreorderLabel = currentButtonText === 'preorder' || currentButtonText === 'preorder now';

    var isOutOfStock = selectedVariant.inventory_management && selectedVariant.inventory_quantity <= 0;
    var isInStock = !isOutOfStock;

    if ((isInStock || sellingPlanAllocations.length === 0) && hasStalePreorderLabel) {
      var button = buttonText.closest('button');
      var status = document.querySelector('.lgm-product-status');
      var registerInterest = document.querySelector('.lgm-register-interest');

      if (isOutOfStock) {
        var isSampleSale = status && status.getAttribute('data-sample-sale') === 'true';
        buttonText.textContent = window.theme && window.theme.strings
          ? window.theme.strings.soldOut
          : 'Sold out';
        if (button) button.disabled = true;
        if (status) {
          status.textContent = isSampleSale
            ? 'This one-off sample pair has sold'
            : 'Currently unavailable - produced and restocked in limited runs';
        }
        if (registerInterest) registerInterest.classList.toggle('hide', isSampleSale);
      } else {
        buttonText.textContent = window.theme && window.theme.strings
          ? window.theme.strings.addToCart
          : 'Add to cart';
        if (button) button.disabled = false;
      }
      buttonText.setAttribute('data-lgm-dibs-button-fallback', 'true');
    }
  }

  function repairDibsPresentation() {
    repairDibsScheduleText();
    repairDibsAvailableVariantButton();
    repairDeferredPurchaseConsent();
  }

  function initialiseDibsScheduleFallback() {
    repairDibsPresentation();

    if (!window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(repairDibsPresentation);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initialiseTaggedGalleries() {
    document.querySelectorAll('[data-lgm-tagged-gallery]').forEach(function (gallery) {
      var endpoint = gallery.getAttribute('data-feed-url');
      var grid = gallery.querySelector('[data-lgm-tagged-grid]');
      var limit = parseInt(gallery.getAttribute('data-limit'), 10) || 8;

      if (!endpoint || !grid) return;

      fetch(endpoint, { credentials: 'omit', mode: 'cors' })
        .then(function (response) {
          if (!response.ok) throw new Error('Tagged gallery unavailable');
          return response.json();
        })
        .then(function (payload) {
          var items = Array.isArray(payload.items) ? payload.items.slice(0, limit) : [];
          var fragment = document.createDocumentFragment();

          items.forEach(function (item) {
            if (!item || !item.image || !item.permalink) return;

            var link = document.createElement('a');
            var image = document.createElement('img');
            link.className = 'lgm-tagged-gallery__item';
            link.href = item.permalink;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.setAttribute('aria-label', item.alt || 'View photographed work');
            image.src = item.image;
            image.alt = item.alt || '';
            image.loading = 'lazy';
            image.decoding = 'async';
            link.appendChild(image);
            fragment.appendChild(link);
          });

          if (fragment.childNodes.length) grid.appendChild(fragment);
          else gallery.hidden = true;
        })
        .catch(function () {
          gallery.hidden = true;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseDibsScheduleFallback);
    document.addEventListener('DOMContentLoaded', initialiseTaggedGalleries);
  } else {
    initialiseDibsScheduleFallback();
    initialiseTaggedGalleries();
  }
})();
